import moment from 'moment'
const THIRTY_MINUTES_IN_MILLISECONDS = 1800000
const FORTY_FIVE_MINUTES_IN_MILLISECONDS = 2700000

const displayBookedLessonEndingTimeForStudent = (bookedLesson) => {
  return bookedLesson.duration === THIRTY_MINUTES_IN_MILLISECONDS ? moment(bookedLesson.bookedTime[0].end).format(
    'HH [giờ] mm [phút], [ngày] DD, MMMM, YYYY'
  ) : bookedLesson.duration === FORTY_FIVE_MINUTES_IN_MILLISECONDS ? moment(bookedLesson.bookedTime[0].end).add(15, 'minutes').format(
    'HH [giờ] mm [phút], [ngày] DD, MMMM, YYYY'
  ) : moment(bookedLesson.bookedTime[0].end).add(30, 'minutes').format(
    'HH [giờ] mm [phút], [ngày] DD, MMMM, YYYY'
  )
}

export default displayBookedLessonEndingTimeForStudent